interface FilterGroupProps {
  title: string;
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
  onClear: () => void;
}

export default function FilterGroup({ title, options, selected, onToggle, onClear }: FilterGroupProps) {
  const isActive = (value: string) =>
    value === "全部" ? selected.length === 0 : selected.includes(value);

  return (
    <div className="pb-5 mb-5 border-b border-background-200 last:border-b-0 last:pb-0 last:mb-0">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-foreground-900">{title}</h3>
        {selected.length > 0 && (
          <button
            type="button"
            onClick={onClear}
            className="text-xs text-primary-600 hover:text-accent-600 transition-colors cursor-pointer"
          >
            清除
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => (option === "全部" ? onClear() : onToggle(option))}
            className={`px-3 py-1.5 rounded-full text-xs transition-colors cursor-pointer whitespace-nowrap ${
              isActive(option)
                ? "bg-primary-500 text-white"
                : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
            }`}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}